import { supabase } from '@/lib/supabase';

const MEMBER_PHOTOS_PREFIX = 'member-photos/';

/** Resolve a stored photo_url (storage path or external URL) to an <img> src. */
export function resolveMemberPhotoUrl(photoUrl: string | null | undefined): string | null {
  if (!photoUrl) return null;
  if (!photoUrl.startsWith(MEMBER_PHOTOS_PREFIX)) return photoUrl;

  const path = photoUrl.slice(MEMBER_PHOTOS_PREFIX.length);
  const { data } = supabase.storage.from('member-photos').getPublicUrl(path);
  return data.publicUrl || null;
}

export function isMemberPhotoStoragePath(photoUrl: string | null | undefined): boolean {
  return Boolean(photoUrl?.startsWith(MEMBER_PHOTOS_PREFIX));
}

export const MEMBER_PHOTO_ALLOWED_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp',
] as const;

export const MEMBER_PHOTO_MAX_SIZE = 5 * 1024 * 1024; // 5 MB
